import { render, staticRenderFns } from "./RegistMessage.vue?vue&type=template&id=16734041&scoped=true&"
import script from "./RegistMessage.vue?vue&type=script&lang=js&"
export * from "./RegistMessage.vue?vue&type=script&lang=js&"
import style1 from "./RegistMessage.vue?vue&type=style&index=1&id=16734041&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16734041",
  null
  
)

export default component.exports